module.exports = __webpack_public_path__ + "img/books_walkthrough_4.5b7b9478.png";